"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkTimeType = exports.SessionActivityTimeOfDay = exports.AuditionActivityTypes = exports.WorkActivityTypes = exports.MealActivityTypes = exports.TravelActivityTypes = exports.sessionActivityTypeTitles = exports.SessionActivityType = void 0;
var SessionActivityType;
(function (SessionActivityType) {
    SessionActivityType["AFMRecordingSession"] = "AFM Recording Session";
    SessionActivityType["WorkTime"] = "Work Time";
    SessionActivityType["WorkTimeNight"] = "Work Time - Night (+10%)";
    SessionActivityType["WorkTimeLateNight"] = "Work Time - Late Night (+20%)";
    SessionActivityType["WorkTimeSaturday"] = "Work Time - Saturday";
    SessionActivityType["WorkTimeSunday"] = "Work Time - Sunday";
    SessionActivityType["WorkTimeHoliday"] = "Work Time - Holiday";
    SessionActivityType["MealBreakfast"] = "Meal - Breakfast";
    SessionActivityType["MealLunch"] = "Meal - Lunch";
    SessionActivityType["MealDinner"] = "Meal - Dinner";
    SessionActivityType["Fitting"] = "Fitting";
    SessionActivityType["WardrobeChange"] = "Wardrobe Change";
    SessionActivityType["HairAndMakeup"] = "Hair And Makeup";
    SessionActivityType["TravelToLocation"] = "Travel To Location";
    SessionActivityType["TravelToLocationAfterMidnight"] = "Travel To Location (After Midnight)";
    SessionActivityType["TravelFromLocation"] = "Travel From Location";
    SessionActivityType["TravelFromLocationAfterMidnight"] = "Travel From Location (After Midnight)";
    SessionActivityType["Audition"] = "Audition";
    SessionActivityType["Rehearsal"] = "Rehearsal";
    SessionActivityType["LineMemorization"] = "Line Memorization";
    SessionActivityType["AuditionScratchTrack"] = "Audition Scratch Track";
    SessionActivityType["RecordingSession"] = "Recording Session";
    SessionActivityType["VoiceOver"] = "Voice Over";
    SessionActivityType["Demo"] = "Demo";
    SessionActivityType["CreativeSession"] = "Creative Session";
    SessionActivityType["CreativeAudition"] = "Creative Audition";
})(SessionActivityType || (exports.SessionActivityType = SessionActivityType = {}));
exports.sessionActivityTypeTitles = {
    [SessionActivityType.WorkTime]: 'Work Session',
    [SessionActivityType.Fitting]: 'Fitting Session',
    [SessionActivityType.TravelToLocation]: 'Travel Session - To Location',
    [SessionActivityType.TravelFromLocation]: 'Travel Session - From Location',
    [SessionActivityType.MealBreakfast]: 'Breakfast',
    [SessionActivityType.MealLunch]: 'Lunch',
    [SessionActivityType.MealDinner]: 'Dinner',
    [SessionActivityType.Audition]: 'Audition',
    [SessionActivityType.LineMemorization]: 'Line Memorization',
    [SessionActivityType.AuditionScratchTrack]: 'Audition Scratch Track',
    [SessionActivityType.Demo]: 'Demo',
    [SessionActivityType.VoiceOver]: 'Voice Over',
    [SessionActivityType.CreativeSession]: 'Creative Session',
    [SessionActivityType.CreativeAudition]: 'Creative Audition',
};
exports.TravelActivityTypes = new Set([
    SessionActivityType.TravelToLocation,
    SessionActivityType.TravelToLocationAfterMidnight,
    SessionActivityType.TravelFromLocation,
    SessionActivityType.TravelFromLocationAfterMidnight,
]);
exports.MealActivityTypes = new Set([
    SessionActivityType.MealBreakfast,
    SessionActivityType.MealLunch,
    SessionActivityType.MealDinner,
]);
exports.WorkActivityTypes = new Set([
    SessionActivityType.WorkTime,
    SessionActivityType.WorkTimeNight,
    SessionActivityType.WorkTimeLateNight,
    SessionActivityType.WorkTimeSaturday,
    SessionActivityType.WorkTimeSunday,
    SessionActivityType.WorkTimeHoliday,
    SessionActivityType.Fitting,
    SessionActivityType.HairAndMakeup,
    SessionActivityType.Audition,
    SessionActivityType.Rehearsal,
    SessionActivityType.RecordingSession,
    SessionActivityType.VoiceOver,
    SessionActivityType.AuditionScratchTrack,
    SessionActivityType.Demo,
    SessionActivityType.CreativeSession,
    SessionActivityType.CreativeAudition,
]);
exports.AuditionActivityTypes = new Set([
    SessionActivityType.Audition,
    SessionActivityType.AuditionScratchTrack,
    SessionActivityType.CreativeAudition,
]);
/**
 * Session Activity Time of Day
 */
var SessionActivityTimeOfDay;
(function (SessionActivityTimeOfDay) {
    SessionActivityTimeOfDay["Night"] = "night";
    SessionActivityTimeOfDay["LateNight"] = "late-night";
    SessionActivityTimeOfDay["AfterMidnight"] = "after-midnight";
})(SessionActivityTimeOfDay || (exports.SessionActivityTimeOfDay = SessionActivityTimeOfDay = {}));
/**
 * Work Time Types
 */
var WorkTimeType;
(function (WorkTimeType) {
    // OnCamera = 'On Camera',
    // OffCamera = 'Off Camera',
    // Overtime = 'Overtime',
    WorkTimeType["StraightTime"] = "Straight Time";
    WorkTimeType["TimeAndOneHalf"] = "Time And One Half";
    WorkTimeType["DoubleTime"] = "Double Time";
    WorkTimeType["NoServiceDay"] = "No Service Day";
    WorkTimeType["NoServiceDayWeekendHoliday"] = "No Service Day (Weekend/Holiday)";
})(WorkTimeType || (exports.WorkTimeType = WorkTimeType = {}));
//# sourceMappingURL=session-activity-types.js.map